var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCa = function SvgCa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20647",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#CF4030"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 12,
    height: 20,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77109 14.3324L9.88359 12.3074C9.52359 12.2174 8.30859 12.4949 7.74609 12.6449L8.08359 11.7449L6.05859 10.0574L6.50859 9.83242L6.17109 8.48242L7.40859 8.70742L7.63359 8.14492L8.87109 9.15742L8.42109 6.68242L9.20859 7.13242L9.99609 5.66992L10.7836 7.13242L11.5711 6.68242L11.2336 9.15742L12.3586 8.14492L12.5836 8.70742L13.9336 8.48242L13.4836 9.83242L13.9336 10.0574L11.7961 11.7449L12.2461 12.6449C11.7061 12.3749 10.5961 12.3074 10.1086 12.3074L10.2211 14.3324H9.77109Z",
    fill: "#CF4030"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ca.51ad07f8da2e53131f051e247ba01dce.svg";